"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.getInitialValue = exports.fields = exports.convertDefaultValue = void 0;
var _find2 = _interopRequireDefault(require("lodash/find"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _columnTypes = _interopRequireDefault(require("./columnTypes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var fields = function fields(settings) {
  var result = [];
  if (settings.columns) {
    settings.columns.forEach(function (column) {
      result.push("value.userRows[].column_".concat(column.id));
    });
  }
  if (settings.rows) {
    // For static rows
    settings.rows.filter(function (item) {
      return item.type === 'static';
    }).forEach(function (row) {
      settings.columns.forEach(function (column) {
        result.push("value.cell_".concat(row.id, "_").concat(column.id));
      });
    });

    // For userList rows
    settings.rows.filter(function (item) {
      return item.type === 'userList';
    }).forEach(function (row) {
      result.push("value.cell_".concat(row.id, "[].pawnId"));
      result.push("value.cell_".concat(row.id, "[].pawnHash"));
      settings.columns.forEach(function (column) {
        result.push("value.cell_".concat(row.id, "[].column_").concat(column.id));
      });
    });
  }
  return ['value.userRows[].id', 'value.userRows[].label'].concat(result);
};
exports.fields = fields;
var getInitialValue = function getInitialValue() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultValueVariables = arguments.length > 1 ? arguments[1] : undefined;
  var defaultValueVariable = settings.defaultValueVariable;
  var initialValue = {};
  if (defaultValueVariable) {
    if (defaultValueVariables) {
      var defaultValue = (0, _get2["default"])(defaultValueVariables, defaultValueVariable);
      if (!defaultValue) {
        console.error("There is no variable \"".concat(defaultValueVariable, "\""));
      } else {
        return convertDefaultValue(defaultValue, settings);
      }
    }
  } else if (settings.rows) {
    settings.rows.filter(function (item) {
      return item.type === 'static';
    }).forEach(function (row) {
      settings.columns.forEach(function (column) {
        var type = column.type;
        if (!_columnTypes["default"][type]) {
          console.error("\"".concat(type, "\" column type is undefined"));
        } else {
          var columnData = (0, _find2["default"])(settings.columnTypes[type], function (item) {
            return item.id === column.id;
          });
          initialValue["cell_".concat(row.id, "_").concat(column.id)] = _columnTypes["default"][type].getInitialValue(columnData);
        }
      });
    });
  }
  return initialValue;
};
exports.getInitialValue = getInitialValue;
var convertDefaultValue = function convertDefaultValue(value, settings) {
  var result = (0, _cloneDeep2["default"])(value);
  if (result.cells) {
    settings.rows.forEach(function (row, rowIndex) {
      settings.columns.forEach(function (column, columnIndex) {
        if (result.cells[rowIndex] && result.cells[rowIndex][columnIndex]) {
          result["cell_".concat(row.id, "_").concat(column.id)] = result.cells[rowIndex][columnIndex];
        }
      });
    });
    delete result.cells;
  }
  if (result.userRows) {
    result.userRows.forEach(function (row, rowIndex) {
      if (row.columns) {
        row.columns.forEach(function (column, columnIndex) {
          var id = settings.columns[columnIndex] && settings.columns[columnIndex].id;
          if (!id) {
            return;
          }
          row["column_".concat(id)] = column;
        });
        delete row.columns;
      }
      row.id = rowIndex + 1;
      row.label = row.label || '';
    });
  }
  return result;
};
exports.convertDefaultValue = convertDefaultValue;
var validate = function validate(value, settings) {
  var errors = {};

  // Validate static rows
  settings.rows.filter(function (item) {
    return item.type === 'static';
  }).forEach(function (row) {
    settings.columns.forEach(function (column) {
      var cell = "cell_".concat(row.id, "_").concat(column.id);
      var columnProps = (0, _find2["default"])(settings.columnTypes[column.type], {
        id: column.id
      });
      var error = _columnTypes["default"][column.type].validate(value[cell], columnProps);
      if (!error) {
        return;
      }
      errors = _objectSpread(_objectSpread({}, errors), {}, _defineProperty({}, cell, error));
    });
  });

  // Validate userLists rows
  settings.rows.filter(function (item) {
    return item.type === 'userList';
  }).forEach(function (row) {
    var cell = "cell_".concat(row.id);
    var error = value[cell].map(function (item1) {
      var result = {};
      settings.columns.forEach(function (column) {
        var columnProps = (0, _find2["default"])(settings.columnTypes[column.type], {
          id: column.id
        });
        result["column_".concat(column.id)] = _columnTypes["default"][column.type].validate(item1["column_".concat(column.id)], columnProps);
      });
      return result;
    });
    errors = _objectSpread(_objectSpread({}, errors), {}, _defineProperty({}, cell, error));
  });
  (0, _forEach2["default"])(value.userRows, function (row, index) {
    (0, _forEach2["default"])(settings.columns, function (column) {
      var cell = "column_".concat(column.id);
      var columnProps = (0, _find2["default"])(settings.columnTypes[column.type], {
        id: column.id
      });
      var error = _columnTypes["default"][column.type].validate(row[cell], columnProps);
      if (!error) {
        return;
      }
      errors.userRows = errors.userRows || [];
      errors.userRows[index] = errors.userRows[index] || {};
      errors.userRows[index][cell] = error;
    });
  });
  return errors;
};
exports.validate = validate;